<div class="shadow-box max-w-screen-md flex flex-col items-center relative">
    <div class="flex flex-row absolute top-2 right-2 p-2">
        @if(showFlag){
        @if(flagged){
        <ng-icon class="text-blue mr-2" size="25" name="faSolidBookmark"></ng-icon>
        } @else {
        <ng-icon class="text-blue mr-2" size="25" name="faBookmark"></ng-icon>
        }
        }
        <app-action-dropdown [question]="question" [bookmarkInfo]="bookmarkInfo" [bookmarked]="_bookmarked"
            (bookmarkedToggled)="toggleBookmarked()" [orderSeed]="orderSeed" />
    </div>
    @if(index && total){
    <span class="font-semibold">{{ index }} von {{ total }}</span>
    } @else if (index){
    <span class="font-semibold">Frage {{ index }}</span>
    }
    <p class="question py-4 px-6">{{ question?.value }}</p>
    <fieldset class="block w-full mt-2 px-6">
        @for(answerOption of question?.expand?.answer_options; track answerOption.id; let i = $index){
        <app-answer-item [isCorrect]="getEvaluation(answerOption.id).correct"
            [isHit]="getEvaluation(answerOption.id).hit" [index]="i + 1" [value]="answerOption.value"
            [id]="getEvaluation(answerOption.id).id"
            [correctCount]="question?.show_expected ? correctCount : undefined" />
        }
    </fieldset>
    <div class="w-full">
        @if(neutralFeedback){
        @if(question?.explanation){
        <div class="border rounded p-2 m-6">
            <p>{{ question?.explanation }}</p>
        </div>
        }
        } @else if(correct){
        <div class="border rounded p-2 m-6">
            @if(correct === 'none'){
            <div class="flex items-center p-2">
                <img src="./assets/img/penguin-no.webp" alt="Leider falsch"
                    class="w-20 h-20 rounded-full mr-4 object-cover" />
                <p>Leider falsch. {{ question?.explanation }}</p>
            </div>
            } @else if (correct === 'some') {
            <div class="flex items-center p-2">
                <img src="./assets/img/penguin-lightbulb.webp" alt="Teilweise richtig"
                    class="w-20 h-20 rounded-full mr-4 object-cover" />
                <p>Teilweise richtig. {{ question?.explanation }}</p>
            </div>
            } @else if(correct === 'all') {
            <div class="flex items-center p-2">
                <img src="./assets/img/exam-end-penguin.webp" alt="Richtig"
                    class="w-20 h-20 rounded-full mr-4 object-cover" />
                <p>Richtig geantwortet! {{ question?.explanation }}</p>
            </div>
            }
        </div>
        }
    </div>
</div>